import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="page"
        title="About KakobuySheet - Our Story, Mission & Values"
        description="Learn about KakobuySheet, the team behind the Kakobuy Spreadsheet directory. Discover our mission, values, and commitment to providing verified spreadsheet resources."
        url="https://kakobuy.boutique/about"
        dateModified="2026-06-25"
      />
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">About Us</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">About KakobuySheet</h1>
          <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            <p>KakobuySheet was founded with a singular mission: to make cross-border product discovery fast, safe, and effortless through the power of organized <strong>Kakobuy Spreadsheet</strong> resources. Our team consists of experienced shoppers and spreadsheet curators who have collectively spent over five years in the cross-border shopping community, building and maintaining the most comprehensive spreadsheet directory available online.</p>
            <p>We believe that everyone deserves access to organized, verified shopping resources. The <strong>Kakobuy Spreadsheet</strong> ecosystem can be overwhelming for newcomers, which is why we created this platform — to serve as a trusted guide that connects shoppers with the latest spreadsheet links, safety tips, and buying guides. Every resource we link to has been reviewed and vetted by our team before being added to our directory.</p>
            <p>Our commitment to daily updates means the <strong>latest Kakobuy Spreadsheet</strong> is always just a click away. We continuously monitor spreadsheet sources, verify new entries, and remove outdated links to ensure our directory remains the most reliable resource for cross-border shoppers worldwide.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Our Values</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Transparency:</strong> We clearly label all external links and never hide where our resources lead.</li>
              <li><strong>Accuracy:</strong> Our Kakobuy Spreadsheet directory is updated daily to maintain link quality and freshness.</li>
              <li><strong>Community First:</strong> We prioritize user safety and provide comprehensive shopping guidelines alongside every resource.</li>
              <li><strong>Accessibility:</strong> All our resources and guides are freely available to everyone, with no registration required.</li>
            </ul>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm">
              <i className="ri-arrow-left-line"></i> Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}